import { render, staticRenderFns } from "./OptionButton.vue?vue&type=template&id=faf55d2c&scoped=true&"
import script from "./OptionButton.vue?vue&type=script&lang=js&"
export * from "./OptionButton.vue?vue&type=script&lang=js&"
import style0 from "./OptionButton.vue?vue&type=style&index=0&id=faf55d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf55d2c",
  null
  
)

export default component.exports